module.exports = __webpack_public_path__ + "assets/img/heading.27d66628.webp";